const style = (theme) => {
  const output = {
    root: {
      overflow: 'hidden',
    },
    wrapper: {
      overflow: 'hidden',
    },
    img: {
      position: 'relative',
      // backgroundSize: 'cover',
      // backgroundRepeat: 'no-repeat',
      // backgroundPosition: 'center',
      '& img': {
        width: '100%',
        height: '100%',
        position: 'absolute',
        objectFit: 'cover',
      },
    },
  }

  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
